(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-bar"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener("DOMContentLoaded", function () {
    const stickyBar = document.getElementById("stickyVariantBar");
    const stickyTitle = document.getElementById("stickyVariantTitle");
    const stickyOptions = document.getElementById("stickyVariantOptions");
    const stickyPrice = document.getElementById("stickyVariantPrice");
    const stickyVariantId = document.getElementById("stickyVariantId");
    const stickyBtn = document.getElementById("stickyAddToCartBtn");
    const stickyImage = document.getElementById("stickyVariantImage");
    function renderStickyVariant() {
        const savedVariant = localStorage.getItem("selectedVariant");
        if (savedVariant) {
            const variant = JSON.parse(savedVariant);
            stickyTitle.textContent = variant.title.split(" / ")[0];
            stickyOptions.textContent = variant.option2 || "";
            stickyPrice.textContent = `$${variant.price}`;
            stickyImage.alt = variant.title;
            stickyVariantId.value = variant.id;
            stickyBtn.textContent = `ADD TO CART • $${variant.price}`;
            
            const selectedFlavorImg = document.querySelector("#flavor-options .flavor-card.selected-variant img[data-img]");
            if (selectedFlavorImg) {
                const imgUrl = selectedFlavorImg.getAttribute("data-img");
                if (imgUrl) {
                    stickyImage.src = imgUrl;
                    console.log("Sticky image set to:", imgUrl);
                }
            } else if (variant.featured_image && variant.featured_image.src) {
                stickyImage.src = variant.featured_image.src;
            }
        } else {
            stickyBar.style.display = "none";
        }
     }
     window.addEventListener("scroll", function () {
        if (window.scrollY > 100) {
            stickyBar.classList.add("downward");
        } else {
            stickyBar.classList.remove("downward");
        }
    });
    renderStickyVariant();
    setInterval(renderStickyVariant, 1000); 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-barnew"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const stickyBar = document.getElementById("stickyVariantBar");
  const stickyTitle = document.getElementById("stickyVariantTitle");
  const stickyOptions = document.getElementById("stickyVariantOptions");
  const stickyPrice = document.getElementById("stickyVariantPrice");
  const stickyVariantId = document.getElementById("stickyVariantId");
  const stickyBtn = document.getElementById("stickyAddToCartBtn");
  const stickyImage = document.getElementById("stickyVariantImage");

  // Show sticky bar after scrolling
  window.addEventListener("scroll", () => {
    stickyBar.style.display = window.scrollY > 700 ? "block" : "none";
  });

  // Format money like Shopify
  const formatMoney = (cents) => {
    return Shopify.formatMoney(cents, "{{ shop.money_format }}");
  };

  // Update bar dynamically
  function updateStickyBar(product, variant) {
    if (!product || !variant) return;

    stickyTitle.textContent = product.title;
    stickyOptions.textContent = variant.title;
    stickyPrice.textContent = formatMoney(variant.price);
    stickyVariantId.value = variant.id;
    stickyBtn.textContent = `ADD TO CART • ${formatMoney(variant.price)}`;
    stickyImage.src = variant.featured_image?.src || product.featured_image?.src || "";
    stickyImage.alt = product.title;

    stickyBar.style.display = "block";
  }

  // Load from localStorage (product + variant)
  function loadFromStorage() {
    const savedProduct = localStorage.getItem("selectedProduct");
    const savedVariant = localStorage.getItem("selectedVariant");

    if (savedProduct && savedVariant) {
      try {
        const product = JSON.parse(savedProduct);
        const variant = JSON.parse(savedVariant);
        updateStickyBar(product, variant);
      } catch (e) {
        console.warn("Invalid stored data");
      }
    }
  }

  // Listen for product change
  document.addEventListener("product:changed", function (event) {
    const { product, variant } = event.detail;
    if (product && variant) {
      // save for next page reload
      localStorage.setItem("selectedProduct", JSON.stringify(product));
      localStorage.setItem("selectedVariant", JSON.stringify(variant));
      updateStickyBar(product, variant);
    }
  });

  // Listen for variant change within the same product
  document.addEventListener("variant:changed", function (event) {
    const variant = event.detail.variant;
    const savedProduct = JSON.parse(localStorage.getItem("selectedProduct") || "{}");
    if (variant && savedProduct) {
      localStorage.setItem("selectedVariant", JSON.stringify(variant));
      updateStickyBar(savedProduct, variant);
    }
  });

  // Initialize on load
  loadFromStorage();
});




// // Handle Sticky Add to Cart - Redirect to Checkout
// const stickyForm = document.getElementById("stickyAddToCartForm");

// if (stickyForm) {
//   stickyForm.addEventListener("submit", function (e) {
//     e.preventDefault(); // Stop default form submission

//     const formData = new FormData(stickyForm);

//     fetch('/cart/add.js', {
//       method: 'POST',
//       body: formData,
//       headers: {
//         'Accept': 'application/json'
//       }
//     })
//     .then(response => {
//       if (response.ok) {
//         // ✅ Redirect to checkout
//         window.location.href = '/checkout';
//       } else {
//         return response.json().then(error => {
//           alert('Error adding to cart: ' + error.description);
//         });
//       }
//     })
//     .catch(error => {
//       console.error('Sticky add to cart failed:', error);
//     });
//   });
// }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const barText = document.querySelector(".landing-top-bar .announcement-text");
  if (!barText) return;

  let timeLeft = parseInt("{{ section.settings.countdown_time | default: 5 }}") * 60;

  function updateCountdown() {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    const formatted = `${minutes}:${seconds.toString().padStart(2, "0")}`;
    
    barText.textContent = `⚡ LIMITED TIME: 20% OFF + FREE SHIPPING - OFFER ENDS IN ${formatted} ⚡`;
    
    if (timeLeft > 0) {
      timeLeft--;
    }
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
});

  } catch(e) { console.error(e); }
})();
})();
